import { Link } from "react-router-dom";
import { Instagram, Linkedin, Github, Twitter, Mail, Phone } from "lucide-react";
import { trackEmailClick, trackPhoneClick, trackWhatsappClick } from "@/lib/analytics";
import { WHATSAPP_DISPLAY, EMAIL, buildWhatsappLink } from "@/lib/constants";

const links = [
  { to: "/solucoes", label: "Soluções" },
  { to: "/planos", label: "Planos" },
  { to: "/tech-partner", label: "Tech Partner" },
  { to: "/projetos", label: "Projetos" },
  { to: "/insights", label: "Insights" },
  { to: "/contacto", label: "Contacto" },
];

const socialLinks = [
  { I: Instagram, n: "instagram", label: "Instagram", href: "https://www.instagram.com/bezierclick" },
  { I: Linkedin, n: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/bezierclick" },
  { I: Github, n: "github", label: "GitHub", href: "https://github.com/Cazubii/bezierclicknew" },
  { I: Twitter, n: "twitter", label: "X", href: "https://x.com/bezierclick" },
];

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#ff6b35] noise border-t-[6px] border-[#0a0a0a] relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10 relative">
        {/* brand */}
        <div className="md:col-span-1">
          <div className="font-display text-3xl text-[#0a0a0a] flex items-center gap-2">
            <span className="inline-block w-3 h-3 bg-[#0a0a0a]" />
            BEZIERCLICK
          </div>
          <p className="text-[#0a0a0a] mt-4 text-sm font-medium">
            Websites, sistemas e automações com IA para empresas em Portugal que querem operar melhor e vender com mais clareza.
          </p>
        </div>

        {/* links */}
        <div>
          <div className="font-mono uppercase text-xs tracking-widest text-[#0a0a0a] mb-4">
            ✦ Navegação
          </div>
          <ul className="space-y-2">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="font-display text-[#0a0a0a] hover:bg-[#0a0a0a] hover:text-white px-1 transition-all"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* contact */}
        <div>
          <div className="font-mono uppercase text-xs tracking-widest text-[#0a0a0a] mb-4">
            ✦ Contato
          </div>
          <a
            data-testid="footer-whatsapp"
            href={buildWhatsappLink()}
            onClick={() => {
              trackPhoneClick("footer_whatsapp");
              trackWhatsappClick("footer");
            }}
            target="_blank"
            rel="noreferrer"
            className="bg-[#0a0a0a] text-white brutal-border px-3 py-2 mb-3 inline-flex items-center gap-2 hover:bg-white hover:text-[#0a0a0a] transition-colors w-full"
          >
            <Phone size={16} className="text-[#ff6b35]" />
            <span className="font-mono text-xs">{WHATSAPP_DISPLAY}</span>
          </a>
          <a
            data-testid="footer-email"
            href={`mailto:${EMAIL}`}
            onClick={() => trackEmailClick("footer")}
            className="bg-[#0a0a0a] text-white brutal-border px-3 py-2 inline-flex items-center gap-2 hover:bg-white hover:text-[#0a0a0a] transition-colors w-full"
          >
            <Mail size={16} className="text-[#ff6b35]" />
            <span className="font-mono text-xs">{EMAIL}</span>
          </a>
        </div>

        {/* social */}
        <div>
          <div className="font-mono uppercase text-xs tracking-widest text-[#0a0a0a] mb-4">
            ✦ Redes
          </div>
          <div className="flex flex-wrap gap-3">
            {socialLinks.map(({ I, n, label, href }) => (
              <a
                key={n}
                href={href}
                aria-label={`Abrir ${label} da BezierClick`}
                data-testid={`footer-social-${n}`}
                target="_blank"
                rel="noreferrer"
                className="w-12 h-12 bg-[#0a0a0a] brutal-border flex items-center justify-center text-[#ff6b35] hover:bg-white hover:text-[#0a0a0a] transition-colors"
              >
                <I size={20} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* big logotype - infinite scroll */}
      <div className="border-t-4 border-[#0a0a0a] footer-marquee" aria-hidden="true">
        <div className="footer-marquee__track">
          <div className="footer-marquee__word font-display text-[#0a0a0a] select-none">
            BEZIERCLICK
          </div>
          <div className="footer-marquee__word font-display text-[#0a0a0a] select-none">
            BEZIERCLICK
          </div>
        </div>
      </div>

      <div className="bg-[#0a0a0a] py-4 text-center">
        <p className="font-mono text-xs uppercase tracking-widest text-white">
          © {new Date().getFullYear()} BEZIERCLICK · desenvolvimento web B2B em Portugal
        </p>
      </div>
    </footer>
  );
};

export default Footer;
